module.exports = __webpack_public_path__ + "img/rotaryDigging-icon2.90522986.png";